@if (bundleProducts) {
<div class="m-t-10">
    <p class="p-b-3 p1">{{ 'Included in this bundle:' | translate}}</p>
    <ng-container *ifNotTradeStore>
        <div class="w-12"
             [grid]="3"
             [gridColumnGap]="3">
            @for (item of bundleProducts; track $index) {
            <div class="ratio-3-4 overflow-hidden">
                <shell></shell>
                <img class="rf"
                     [image]="item.product.data?.image">
            </div>
            }
        </div>
    </ng-container>
    <ng-container *ifTradeStore>
        <carousel class="w-12"
                  [slidesPerView]="3.33"
                  [spaceBetween]="12"
                  [freeMode]="true"
                  [navigation]="{
                         nextEl: '.product-bundle-options-selected-button-next',
                         prevEl: '.product-bundle-options-selected-button-prev'
                    }">
            @for (item of bundleProducts; track $index) {
            <ng-template swiperSlide>
                <div class="ratio-3-4 overflow-hidden">
                    <div class="inline-block pos-absolute top-1 right-1 z-1 p-r-1 p-l-1 bg-col-6 col-w c1">x{{
                        item.qty }}</div>
                    <shell></shell>
                    <img class="rf"
                         [image]="item.product.data?.image">
                </div>
            </ng-template>
            }
            @if (bundleProducts.length > 3) {
            <div slot="container-start">
                <button class="pos-absolute top-50 left-1 z-5 box-shadow-1 _carousel-arrow product-bundle-options-selected-button-prev"
                        type="button"
                        [attr.aria-label]="'Previous slide' | translate">
                    <i class="icon-chevron-left"
                       aria-hidden="true"></i>
                </button>
                <button class="pos-absolute top-50 right-1 z-5 box-shadow-1 _carousel-arrow product-bundle-options-selected-button-next"
                        type="button"
                        [attr.aria-label]="'Next slide' | translate">
                    <i class="icon-chevron-right"
                       aria-hidden="true"></i>
                </button>
            </div>
            }
        </carousel>
        <button class="m-t-1 button-inline-2"
                [iCmsModalOpen]="bundleModalId"
                [iCmsModalOpenData]="{
                    product,
                    selection: bundleSelection,
                    buyRequest,
                    qty
                  }">{{ 'View all' | translate }}</button>
    </ng-container>
</div>
}